import Model from '../Model'

export default class Partner extends Model {
  resource () {
    return 'partners'
  }

  primaryKey () {
    return 'id'
  }
}
